const isUndefined = (value) => typeof value === 'undefined';

export { isUndefined };
//# sourceMappingURL=isUndefined.js.map
